import z from "zod";
import { timestampsSchema } from "../helpers";
export var DeviceStateEnum;
(function (DeviceStateEnum) {
    DeviceStateEnum["ENROLLED"] = "ENROLLED";
    DeviceStateEnum["ASSIGNED"] = "ASSIGNED";
    DeviceStateEnum["REVOKED"] = "REVOKED";
})(DeviceStateEnum || (DeviceStateEnum = {}));
export const deviceIdSchema = z
    .string()
    .min(16)
    .max(64)
    .regex(/^[A-Za-z0-9_-]+$/, "device id must be URL-safe base64url");
export const deviceCameraSchema = z.object({
    mxid: z.string().min(1).max(64),
    name: z.string().max(128).nullable(),
    lastSeenAt: z.iso.datetime(),
});
export const deviceSchema = z.object({
    id: z.number(),
    deviceId: deviceIdSchema,
    organizationId: z.number().nullable(),
    state: z.enum(DeviceStateEnum),
    firmwareVersion: z.string().nullable(),
    lastSeenAt: z.iso.datetime().nullable(),
    assignedAt: z.iso.datetime().nullable(),
    assignedByUserId: z.number().nullable(),
    online: z.boolean(),
    cameras: z.array(deviceCameraSchema),
    ...timestampsSchema,
});
export const enrollDeviceRequestSchema = z.object({
    deviceId: deviceIdSchema,
    publicKey: z.string().min(1).max(512),
    firmwareVersion: z.string().max(64).nullish(),
});
export const enrollDeviceResponseSchema = z.object({
    deviceId: deviceIdSchema,
    state: z.enum(DeviceStateEnum),
    relayPublicKey: z.string(),
    relayKeyId: z.string(),
});
export const assignDeviceRequestSchema = z.object({
    organizationId: z.number().int().positive(),
});
export const deviceListResponseSchema = z.object({
    devices: z.array(deviceSchema),
});
export const deviceHeartbeatRequestSchema = z.object({
    firmwareVersion: z.string().max(64).nullish(),
    cameras: z
        .array(z.object({
        mxid: z.string().min(1).max(64),
        name: z.string().max(128).nullish(),
    }))
        .default([]),
});
export const deviceSelfResponseSchema = z.object({
    deviceId: deviceIdSchema,
    state: z.enum(DeviceStateEnum),
    assigned: z.boolean(),
    relayToken: z.string().nullable(),
});
export const iceServerSchema = z.object({
    urls: z.array(z.string()),
    username: z.string().optional(),
    credential: z.string().optional(),
});
export const iceConfigResponseSchema = z.object({
    iceServers: z.array(iceServerSchema),
    ttl: z.number().int().positive(),
});
export const relaySessionTokenResponseSchema = z.object({
    token: z.string(),
    relayUrl: z.url(),
    expiresIn: z.number().int().positive(),
});
//# sourceMappingURL=devices.schema.js.map